import { faEye } from "@fortawesome/pro-regular-svg-icons/faEye";
import { faComments } from "@fortawesome/pro-solid-svg-icons/faComments";
import { Grid, Tab, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import * as api from "api/Core";
import { DefaultListParameters } from "assets/appConfig";
import { AppMessageBox } from "components/AppMessageBox";
import { AppTabs } from "components/AppTabs";
import IconButtonCancel from "components/Buttons/IconButtonCancel";
import { SpinnerIndicator } from "components/CallServer";
import DashListBox, { DashBoxListItem } from "components/Dashboard/DashListBox";
import IconCreatePublication from "components/Icons/IconCreatePublication";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiLink from "components/MuiExtras/MuiLink";
import MuiPagination from "components/MuiExtras/MuiPagination";
import MuiPaper from "components/MuiExtras/MuiPaper";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import MuiReverse from "components/MuiExtras/Typography/MuiReverse";
import { TextPluralization } from 'components/TextPluralization';
import { Formaters } from "lib/Formarters";
import { PublicationType } from "models/ApiEnums";
import { DashboardGraphModel, DashboardPeriod, DashboardUserEvolutionPublicationListColumn, DashboardUserEvolutionPublicationListModel, DashboardUserEvolutionPublicationResumeModel, PagedResult } from "models/ApiModels";
import moment from "moment";
import * as React from "react";
import { RenderGraphGmtInfo } from "views/Dashboards/components/RenderGraphGmtInfo";
import { RenderLineGraph } from "views/Dashboards/components/RenderLineGraph";
import { CommonProps } from "views/Dashboards/UserEvolutionDashboard";
import PublicationCommentsDialog from "views/Publication/Dialogs/PublicationCommentsDialog";
import PublicationViewersDrawer from "views/Publication/Dialogs/PublicationViewersDrawer";
import { getPublicationUrl } from "views/Timeline/Components/FeedHelpers";
import PublicationLikesReviewDrawer from "views/Timeline/Dialogs/PublicationLikesReviewDrawer";
import PublicationThanksReviewDrawer from "views/Timeline/Dialogs/PublicationThanksReviewDrawer";


/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    userId: string;
}

type LocalProps = IProps & CommonProps;

/////////////////////////////////////////////////////////////////////////////////////

interface ICreateTileProps {
    activeTile: DashboardUserEvolutionPublicationListColumn;
    data: DashboardUserEvolutionPublicationResumeModel;
    onChange: (tile: DashboardUserEvolutionPublicationListColumn) => void;
}

type CreateTileProps = ICreateTileProps & LocalProps;

class CreateTiles extends React.PureComponent<CreateTileProps>
{
    private handleTileClick(tile: DashboardUserEvolutionPublicationListColumn) {
        this.props.onChange(tile);
    }

    ///
    private res(r: string, collection: any = null) {
        return this.props.t("Views.Dashboards.UserEvolution.Publication.CreateTiles." + r, collection);
    }

    //
    public render() {
        const { activeTile, data } = this.props;

        let views30 = 0, likes30 = 0, thanks30 = 0, comments30 = 0;
        data.days.forEach((v) => {
            views30 += v.views;
            comments30 += v.comments;
            likes30 += v.likes;
            thanks30 += v.thanks;
        });

        var boxes: DashBoxListItem[] = [
            {
                key: DashboardUserEvolutionPublicationListColumn.Views,
                title: data.views,
                subtitle: this.res("ViewsSubtitle"),
                description: this.res("Description", { count: views30 }),
                icon: faEye,
            },
            {
                key: DashboardUserEvolutionPublicationListColumn.Comments,
                title: data.comments,
                subtitle: this.res("CommentsSubtitle"),
                description: this.res("Description", { count: comments30 }),
                icon: faComments,
            },
            {
                key: DashboardUserEvolutionPublicationListColumn.Likes,
                title: data.likes,
                subtitle: this.res("LikesSubtitle"),
                description: this.res("Description", { count: likes30 }),
                icon: faComments,
            },
            {
                key: DashboardUserEvolutionPublicationListColumn.Thanks,
                title: data.thanks,
                subtitle: this.res("ThanksSubtitle"),
                description: this.res("Description", { count: thanks30 }),
                icon: faComments,
            }
        ];

        return (
            <MuiContainer margin="normal">
                <DashListBox
                    color="info"
                    boxes={boxes}
                    active={activeTile}
                    onClick={(key: DashboardUserEvolutionPublicationListColumn) => this.handleTileClick(key)}
                />
            </MuiContainer>
        );
    }
}

////////////////////////////////////////////////////////////////////////////////////////////////////

interface IGraphProps {
    data: DashboardUserEvolutionPublicationResumeModel;
    tile: DashboardUserEvolutionPublicationListColumn;
    onDayClick: (day: Date) => void;
}

class CreateGraph extends React.PureComponent<IGraphProps & CommonProps> {

    ///
    private res(r: string, collection: any = null) {
        return this.props.t("Views.Dashboards.UserEvolution.Publication.CreateGraph." + r, collection);
    }

    ///
    render() {
        const { data: { days }, onDayClick, tile } = this.props;

        var ds: DashboardGraphModel[] = [];
        var t = DashboardUserEvolutionPublicationListColumn[this.props.tile].toLowerCase();

        days.forEach((v, index) => {
            ds.push({ day: v.day, total: v[t] });
        });

        const title = tile == DashboardUserEvolutionPublicationListColumn.Views
            ? this.res("ViewTitle")
            : tile == DashboardUserEvolutionPublicationListColumn.Comments
                ? this.res("CommentsTitle")
                : tile == DashboardUserEvolutionPublicationListColumn.Thanks
                    ? this.res("ThanksTitle")
                    : this.res("LikesTitle");

        return (
            <>
                <MuiContainer margin="dense" >
                    <Typography component="p" variant="h6"><b>{title.toString().toLocaleUpperCase()}</b></Typography>
                    <MuiMuted>
                        <small><RenderGraphGmtInfo /></small>
                    </MuiMuted>
                </MuiContainer>

                <RenderLineGraph color="blue" data={ds} onSelectDay={onDayClick} />
            </>
        );
    };
}

/////////////////////////////////////////////////////////////////////////////////////////////

interface IListProps extends LocalProps {
    tile: DashboardUserEvolutionPublicationListColumn;
    selectedDay?: Date;
    firstDay?: Date;
    lastDay?: Date;
    onCancelDay: () => void;
}

interface CreateListState {
    dialog: any;
    data: PagedResult<DashboardUserEvolutionPublicationListModel>;
    offset: number;
    loading: boolean;
    tabOption: DashboardPeriod;
}

class CreateList extends React.PureComponent<IListProps, CreateListState> {

    constructor(props: IListProps) {
        super(props);

        this.state = {
            dialog: null,
            data: null,
            offset: null,
            loading: true,
            tabOption: DashboardPeriod.Last30
        };
    }

    ///
    private res(r: string, f: any = null) {
        return this.props.t("Views.Dashboards.UserEvolution.Publication.CreateList." + r, f);
    }

    ///
    private loadData(offset: number) {

        this.setState({ loading: true });

        api.getUserEvolutionPublicationAnalytic(
            {
                userId: this.props.userId,
                period: this.state.tabOption,
                day: this.props.selectedDay ? this.props.selectedDay.convertUtcToLocalDate() : null,
                column: this.props.tile,
                range: { offset, take: DefaultListParameters.viewRecordsByPage }
            })
            .then((result) => {
                this.setState({ data: result, loading: false, offset: offset });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false, offset: 0 });
            });
    }

    ///
    private getDateFilter() {

        if (this.state.tabOption == DashboardPeriod.Day) {
            return {
                startDate: this.props.selectedDay.convertUtcToLocalDate(),
                endDate: this.props.selectedDay.putEndOfDay().convertUtcToLocalDate()
            };
        }
        else if (this.state.tabOption == DashboardPeriod.Last30) {
            return {
                startDate: this.props.firstDay.convertUtcToLocalDate(),
                endDate: this.props.lastDay.putEndOfDay().convertUtcToLocalDate()
            };
        }

        return { startDate: null, endDate: null };
    }

    ///
    private handleLikeReviewClick = (publicationId: string) => {
        var filter = this.getDateFilter();

        this.setState({
            dialog: <PublicationLikesReviewDrawer
                publicationId={publicationId}
                {...filter}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleThanksReviewClick = (publicationId: string) => {
        this.setState({
            dialog: <PublicationThanksReviewDrawer
                publicationId={publicationId}
                canAddThanks={false}
                {...this.getDateFilter()}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleViewClick = (publicationId: string) => {
        this.setState({
            dialog: <PublicationViewersDrawer
                publicationId={publicationId}
                {...this.getDateFilter()}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private handleCommentClick = (publicationId: string) => {
        this.setState({
            dialog: <PublicationCommentsDialog
                publicationId={publicationId}
                onClose={() => this.setState({ dialog: null })}
            />
        });
    };

    ///
    private renderTitle() {

        const title = this.props.tile == DashboardUserEvolutionPublicationListColumn.Views
            ? this.res("ViewsTitle")
            : this.props.tile == DashboardUserEvolutionPublicationListColumn.Comments
                ? this.res("CommentsTitle")
                : this.props.tile == DashboardUserEvolutionPublicationListColumn.Thanks
                    ? this.res("ThanksTitle")
                    : this.res("LikesTitle");

        const sDay = this.props.selectedDay ? moment(this.props.selectedDay).format("DD/MMM") : null;

        return (
            <MuiContainer margin="dense" >
                <Grid container justifyContent="space-between" alignItems="center">
                    <Grid item>
                        <Typography variant="button">{title}</Typography>
                    </Grid>
                    <Grid item>

                        {
                            this.props.selectedDay
                                ? (
                                    <MuiReverse color="warning">
                                        <b>{`${Formaters.capitalize(this.props.t("Glossary.Day"))} ${sDay}`}</b>
                                        <IconButtonCancel
                                            size="small"
                                            onClick={() => this.props.onCancelDay()}
                                        />
                                    </MuiReverse>
                                )
                                : (
                                    <AppTabs
                                        value={this.state.tabOption}
                                        onChange={
                                            (e, newValue: DashboardPeriod) => {
                                                this.setState({ tabOption: newValue }, () => this.loadData(0));
                                            }
                                        }
                                        indicatorColor="primary"
                                        textColor="primary"
                                    >
                                        <Tab label={this.props.t<string>("Views.Dashboards.Common.InLastMonth")} value={DashboardPeriod.Last30} />
                                        <Tab label={this.props.t<string>("Views.Dashboards.Common.FullPeriod")} value={DashboardPeriod.All} />
                                    </AppTabs>
                                )
                        }
                    </Grid>
                </Grid>
            </MuiContainer>
        );
    }

    ///
    private renderList() {
        const { data: { items, total }, dialog, offset } = this.state;

        const valueClick = this.props.tile == DashboardUserEvolutionPublicationListColumn.Views
            ? this.handleViewClick
            : this.props.tile == DashboardUserEvolutionPublicationListColumn.Comments
                ? this.handleCommentClick
                : this.props.tile == DashboardUserEvolutionPublicationListColumn.Thanks
                    ? this.handleThanksReviewClick
                    : this.handleLikeReviewClick;

        return (
            <MuiContainer margin="normal">
                <>
                    {dialog}
                    <br />
                    {this.renderTitle()}

                    {
                        this.props.selectedDay == null && total == 0
                            ? <MuiMessageBox
                                variant="info"
                                message={
                                    this.res(
                                        this.props.tile == DashboardUserEvolutionPublicationListColumn.Views
                                            ? "EmptyViewsData"
                                            : this.props.tile == DashboardUserEvolutionPublicationListColumn.Comments
                                                ? "EmptyCommentsData"
                                                : this.props.tile == DashboardUserEvolutionPublicationListColumn.Thanks
                                                    ? "EmptyThanksData"
                                                    : "EmptyLikesData"
                                    )
                                }
                            />
                            : total == 0
                                ? <MuiMessageBox
                                    variant="info"
                                    message={
                                        this.res(
                                            this.props.tile == DashboardUserEvolutionPublicationListColumn.Views
                                                ? "EmptyFilteredViewsData"
                                                : this.props.tile == DashboardUserEvolutionPublicationListColumn.Comments
                                                    ? "EmptyFilteredCommentsData"
                                                    : this.props.tile == DashboardUserEvolutionPublicationListColumn.Thanks
                                                        ? "EmptyFilteredThanksData"
                                                        : "EmptyFilteredLikesData"
                                        )
                                    }
                                />
                                : (
                                    <>
                                        <MuiContainer>
                                            <Table size="small">
                                                <TableBody>
                                                    {
                                                        items.map((v, index) => {

                                                            var pubUrl = getPublicationUrl(v.publicationId, v.publicationType, v.parentId);

                                                            return (
                                                                <TableRow key={index}>
                                                                    <TableCell style={{ width: 1, verticalAlign: "top" }}>{offset + index + 1}</TableCell>
                                                                    <TableCell style={{ width: 1 }}>
                                                                        <MuiLink href={pubUrl} target="_blank">
                                                                            {
                                                                                v.thumbnailUrl
                                                                                    ? <img src={v.thumbnailUrl} alt={v.title} style={{ maxWidth: 64 }} />
                                                                                    : <IconCreatePublication color="muted" size="3x" />
                                                                            }
                                                                        </MuiLink>
                                                                    </TableCell>
                                                                    <TableCell style={{ verticalAlign: "top" }}>
                                                                        <MuiLink href={pubUrl} color="secondary" target="_blank">
                                                                            {v.publicationType == PublicationType.Answer && <i>[Resposta] </i>}
                                                                            {v.title}
                                                                        </MuiLink>
                                                                        <MuiMuted><small>
                                                                            <div>{this.res("PublishedIn")} {Formaters.relativeTime(v.creationDate)}</div>
                                                                            {
                                                                                this.state.tabOption == DashboardPeriod.Last30 &&
                                                                                <div>
                                                                                    <TextPluralization count={v.publicationTotal}
                                                                                        resource=
                                                                                        {
                                                                                            this.res(
                                                                                                this.props.tile == DashboardUserEvolutionPublicationListColumn.Views
                                                                                                    ? "TotalViews"
                                                                                                    : this.props.tile == DashboardUserEvolutionPublicationListColumn.Comments
                                                                                                        ? "TotalComments"
                                                                                                        : this.props.tile == DashboardUserEvolutionPublicationListColumn.Thanks
                                                                                                            ? "TotalThanks"
                                                                                                            : "TotalLikes"
                                                                                                , { count: v.publicationTotal }
                                                                                            )
                                                                                        }
                                                                                    />
                                                                                </div>
                                                                            }
                                                                        </small></MuiMuted>
                                                                    </TableCell>
                                                                    <TableCell align="right" style={{ verticalAlign: "top" }}>
                                                                        <MuiLink onClick={() => valueClick(v.publicationId)}>
                                                                            {v.columnTotal}
                                                                        </MuiLink>
                                                                    </TableCell>
                                                                </TableRow>
                                                            );
                                                        })
                                                    }
                                                </TableBody>
                                            </Table>
                                        </MuiContainer>
                                        <MuiPagination
                                            limit={DefaultListParameters.viewRecordsByPage}
                                            offset={this.state.offset}
                                            total={total}
                                            onClick={(e, offset) => this.loadData(offset)}
                                        />
                                    </>
                                )
                    }
                </>
            </MuiContainer >
        );
    }

    ///
    private checkForUpdateState(prevProps: IListProps) {
        if (this.props.selectedDay && this.props.selectedDay != prevProps.selectedDay) {
            this.setState({ tabOption: DashboardPeriod.Day }, () => this.loadData(0));
        }
        else if ((this.props.selectedDay == null && prevProps.selectedDay != null) || this.props.tile != prevProps.tile) {
            this.setState({ tabOption: DashboardPeriod.Last30 }, () => this.loadData(0));
        }
    }

    ///
    public componentDidMount() {
        this.loadData(0);
    }

    //
    public componentDidUpdate(prevProps: IListProps) {
        this.checkForUpdateState(prevProps);
    }

    ///
    public render() {

        if (this.state.loading)
            return <SpinnerIndicator />;

        if (this.state.data == null)
            return <AppMessageBox resource="LoadListDataFailed" />;

        return this.renderList();
    }
}

////////////////////////////////////////////////////////////////////////////////////////

interface UserEvolutionPublicationState {
    data: DashboardUserEvolutionPublicationResumeModel;
    loading: boolean;
    selectedDay?: Date;
    tile: DashboardUserEvolutionPublicationListColumn;
}

class UserEvolutionPublication extends React.PureComponent<LocalProps, UserEvolutionPublicationState> {

    constructor(props: LocalProps) {
        super(props);
        this.state = {
            data: null,
            loading: true,
            tile: DashboardUserEvolutionPublicationListColumn.Views,
        };
    }

    private loadData() {

        api.getUserEvolutionPublicationResume(this.props.userId)
            .then((result) => {

                result.days.forEach((v) => {
                    v.day = v.day.convertLocalToUtcDate();
                });

                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ data: null, loading: false });
            });
    }

    public componentDidMount() {
        this.loadData();
    }

    public render() {
        const { tile, data, loading } = this.state;

        if (loading)
            return <SpinnerIndicator />;

        if (data == null)
            return <AppMessageBox resource="LoadGraphDataFailed" />;

        const firstDay = data.days.length > 0 ? data.days[0].day : null;
        const lastDay = data.days.length > 0 ? data.days[data.days.length - 1].day : null;

        return (
            <>
                <CreateTiles
                    {...this.props}
                    userId={this.props.userId}
                    data={data}
                    activeTile={this.state.tile}
                    onChange={(tile) => this.setState({ tile: tile, selectedDay: null })}
                />

                <MuiContainer margin="normal">
                    <MuiPaper borderVariant="accentedRound" borderColor="info">

                        <MuiContainer margin="normal">
                            <CreateGraph
                                {...this.props}
                                data={data}
                                tile={tile}
                                onDayClick={
                                    (day: Date) => {
                                        this.setState({ selectedDay: day });
                                    }
                                }
                            />
                        </MuiContainer>

                        <CreateList
                            {...this.props}
                            userId={this.props.userId}
                            tile={tile}
                            selectedDay={this.state.selectedDay}
                            firstDay={firstDay}
                            lastDay={lastDay}
                            onCancelDay={() => this.setState({ selectedDay: null })}
                        />

                    </MuiPaper>
                </MuiContainer>

            </>
        );
    }
}

export default UserEvolutionPublication;